import tippy from "tippy.js"

// # General usage
// ------------------
// When adding this hook, any Tippy prop from https://atomiks.github.io/tippyjs/v6/all-props/ can be used using `data-tippy-` prefix.
// For example, `data-tippy-placement="left"` will set the placement to left.
// 
// # Setting content
// ------------------
// The hook will try to find an inner element with the `data-tippy-content` attribute and use its `innerHTML` as the content of the tooltip.
// If no such element is found, the hook won't do anything special - for simple text content, you can set `data-tippy-content` on the element itself.
// Content inside a nested element with this hook belongs to that element's tooltip, so it is skipped.

export const Tippy = {
  mounted() {
    this.instance = this.new_instance(this.el);
  },
  updated() {
    this.instance.destroy();
    this.instance = this.new_instance(this.el);
  },
  destroyed() {
    this.instance.destroy();
  },

  new_instance(el) {
    const tippyContentElement = Array.from(el.querySelectorAll("[data-tippy-content]")).find(
      (content) => content.closest('[phx-hook="Tippy"]') === el
    );

    if (tippyContentElement == null) {
      return tippy(el);
    } else {
      return tippy(el, {
        content: tippyContentElement.innerHTML,
        allowHTML: true,
        theme: tippyContentElement.dataset.tippyTheme
      });
    }
  }
};
